
import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { Defaults } from 'src/app/Utilities/defaults';
import { IVisitTypes } from 'src/app/models/IVisitTypes';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { IProviderDetails } from 'src/app/models/IProviderDetails';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
import { OrNoteHeaderComponent } from 'src/app/PatientChart/OR-Note/or-note-header/or-note-header.component';
import { IRoomsInfo } from 'src/app/models/IRoomsInfo';
import { ILocationDetails } from 'src/app/models/ILocationDetails';
import { PersonalInfoService } from 'src/app/Services/Demographics/personal-info.service';
import { IReferralDetails } from 'src/app/models/IReferralDetails';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { IAppointmentData } from 'src/app/models/IAppointmentDetails';
import { IAuthorization } from 'src/app/models/IAuthorization';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-or-visit-details',
  templateUrl: './or-visit-details.component.html',
  styleUrls: ['./or-visit-details.component.css']
})
export class OrVisitDetailsComponent implements OnInit {
  visitDetailsForm: FormGroup;
  submitted = false;
  public lstVistTypes: IVisitTypes[];
  public lstProviders: IUserDetails[];
  public supervisingProviders: IUserDetails[];
  public billingProviders: IUserDetails[];
  public lstRooms: IRoomsInfo[];
  public lstLocations: ILocationDetails[];
  public lstReferralDetails: IReferralDetails[];
  public lstReferralFrom: IReferralDetails[];
  public appointmentDetails: IAppointmentData;
  public authorizationCodes: IAuthorization[];
  public appointmentId: string;
  public isSignOff: boolean = false;
  public chkcancel: boolean = false;
  @Output() valueChange = new EventEmitter();  // value change for child component to parent component (visit note header)

  disableAfterSignOff: boolean = false;
  disableAfterSignOffDOS: boolean = true;
  constructor(private formBuilder: FormBuilder, public dialogRef: MatDialogRef<OrNoteHeaderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private sharedService: SharedService, private schedulerservice: SchedularServiceService, private router: Router
    , private personalService: PersonalInfoService, private toastr: ToastrService, private ornoteheader: OrNoteHeaderComponent) {
    this.isSignOff = data.signOff;
    this.getSystem();
    this.onLoad();
    this.getVisitDetails();

  }


  ngOnInit() {
    this.visitDetailsForm = this.formBuilder.group({
      patientName: ['',],
      billingProvider: ['',],
      physician: ['',],
      locationId: ['',],
      supervisorProvider: ['',],
      referralName: ['',],
      authId: ['',],
      start: ['',],
      refDate: ['',],
      visitId: ['',],
      financialCenter: ['',],
      comments: ['',]
    });
  }


  onCancelClick(): void {
    //this.dialogRef.close();
    if (this.ornoteheader != null)
      this.ornoteheader._toggleSidebar(this.chkcancel);
  }

  onLoad() {
    this.sharedService.getAllUsersByRole(Defaults.doctorType).subscribe(data => {
      this.lstProviders = data;
      this.supervisingProviders = data;
      this.billingProviders = data;
    });
    this.schedulerservice.getVisitTypes().subscribe(data => {
      this.lstVistTypes = data;
    });
    //  this.schedulerservice.getRooms().subscribe(data => {
    //   this.lstRooms = data;
    //  });
    this.schedulerservice.getLocations().subscribe(data => {
      this.lstLocations = data;
    });

    // this.schedulerservice.getBillingUsers().subscribe(data => {
    //   this.billingProviders = data;
    // });

    this.personalService.getReferalProvidersInfo().subscribe(data => {
      this.lstReferralDetails = data;
      this.lstReferralFrom = this.lstReferralDetails.filter((referral: IReferralDetails) => referral.providerType === 'REF');
    });

    this.personalService.getAuthorizationCodes(CommonComponents.patientId).subscribe(data => {
      this.authorizationCodes = data;
    })

  }

  getSystem() {
    if (CommonComponents.encounterId == null || CommonComponents.encounterId == undefined) {
      CommonComponents.encounterId = sessionStorage.getItem("encounterid");
    }
    if (CommonComponents.patientId == null || CommonComponents.patientId == undefined) {
      CommonComponents.patientId = parseInt(sessionStorage.getItem("patientId"));
    }
  }

  getVisitDetails() {
    this.schedulerservice.getVisitDetails(CommonComponents.encounterId).subscribe(data => {
      this.appointmentDetails = data;

      this.appointmentId = this.appointmentDetails.Id;
      if (this.appointmentDetails != null && this.appointmentDetails != undefined) {
        this.visitDetailsForm.patchValue({
          patientName: this.appointmentDetails.patientName,
          billingProvider: this.appointmentDetails.billingProvider,
          physician: this.appointmentDetails.physician,
          locationId: this.appointmentDetails.locationId,
          visitId: this.appointmentDetails.visitId.toString(),
          supervisorProvider: this.appointmentDetails.supervisorProvider,
          referralName: this.appointmentDetails.referralName,
          start: this.appointmentDetails.start,
          comments: this.appointmentDetails.comments,
          authId: this.appointmentDetails.authId
        })

        if (this.appointmentDetails.screen == "VisitSignOff" || this.appointmentDetails.screen == "ORSignOff") {
          this.disableAfterSignOff = true;
          this.visitDetailsForm.disable();
        }
        this.disableForm();
      }
    })

  }

  disableForm() {
    if (this.isSignOff == true) {
      this.visitDetailsForm.disable();
    }
  }

  onSubmit() {
    this.submitted = true;

    if (this.visitDetailsForm.invalid) {
      return;
    }
  }

  saveVisitDetails() {

    if (this.appointmentId != null && this.appointmentId != undefined) {

      this.appointmentDetails = this.visitDetailsForm.value;
      this.appointmentDetails.Id = this.appointmentId;
      this.schedulerservice.updateVisitDetails(this.appointmentDetails).subscribe(data => {
        this.toastr.success(data);
        // this.displayRendringProvider.emit(this.appointmentDetails.physician);
        var urltext = this.router.url;
        this.valueChange.emit(this.appointmentDetails.physician);
        //  sessionStorage.setItem("operativeReport", 'true');
        // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
        //   this.router.navigate([urltext]));
        if (this.ornoteheader != null)
          this.ornoteheader._toggleSidebar(this.chkcancel);
      })
    }
  }

}
